module.exports = __webpack_public_path__ + "img/9791196149987.f8076718.jpg";